import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { fontWeight } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style, styleVariants } from '@vanilla-extract/css';

export const streamPriceLabelContainerBase = style([
  {
    whiteSpace: 'nowrap',
  },
]);

export const streamPriceLabelContainer = styleVariants({
  primary: [
    streamPriceLabelContainerBase,
    typography.bodyMd,
    {
      color: themeVars.container.foreground.primary,
    },
  ],
  secondary: [
    streamPriceLabelContainerBase,
    typography.labelMd,
    {
      color: themeVars.container.foreground.secondary,
    },
  ],
});

export const streamPriceLabelHighlighted = style([
  typography.bodyLg,
  { fontWeight: fontWeight.semibold },
]);
